import { AbstractControl } from '@angular/forms';

declare var require: any;
const ibantools = require('ibantools');

export const swiftValidator = (control: AbstractControl) => {
  const codeSwiftValid = ibantools.isValidBIC(control.value);
  return codeSwiftValid ? null : { validSwift: true };
};
